import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { hasRoutePermission } from '../config/permissions';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, user, defaultRoute } = useAuth();
  const location = useLocation();

  // Mostrar loading enquanto verifica
  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%)',
        }}
      >
        <CircularProgress size={60} sx={{ color: '#14b8a6', mb: 2 }} />
        <Typography variant="h6" sx={{ color: '#0d9488' }}>
          Verificando autenticação...
        </Typography>
      </Box>
    );
  }

  // Se não estiver autenticado, redirecionar para login
  if (!isAuthenticated || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Permissões: admin/admin_master tratados em hasRoutePermission (trechos só master)
  if (!hasRoutePermission(user.role, location.pathname)) {
    return <Navigate to={defaultRoute} replace />;
  }

  // Se estiver autenticado e com permissão, mostrar o conteúdo
  return <>{children}</>;
};

export default ProtectedRoute;
